module.exports = __webpack_public_path__ + "static/media/slide-2.f6f2b8e0.png";